import BodyText from 'LuxKit/Typography/BodyText'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import getPropertyIcon from 'lib/offer/getPropertyIcon'
import { rem } from 'polished'
import type { ComponentProps, ReactNode } from 'react'
import { useMemo } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: grid;
  grid-template: "icon description" auto / auto minmax(0px, 1fr);
  gap: ${rem(4)};
`

const DescriptionCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(4)};
  min-width: 0;
`

type InheritedBodyTextProps = Pick<ComponentProps<typeof BodyText>, 'lineClamp'>

export type SearchTileRowInclusion = App.OfferInclusion & {
  propertyIconName?: App.Property.IconName
}

interface Props extends InheritedBodyTextProps {
  inclusion: SearchTileRowInclusion
  /**
   * @default `inclusion.isHighlighted``
   */
  isHighlighted?: boolean
  endIcon?: ReactNode
}

function SearchTileRowInclusionItem({
  inclusion,
  lineClamp,
  isHighlighted,
  endIcon,
}: Props) {
  const Icon = useMemo(() => {
    if (inclusion.propertyIconName) return getPropertyIcon(inclusion.propertyIconName)

    return getOfferFeatureIcon(inclusion.symbol)
  }, [inclusion.propertyIconName, inclusion.symbol])
  const highlighted = isHighlighted === undefined ? inclusion.isHighlighted : isHighlighted
  const isLuxPlusBonus = inclusion.isLuxPlusBonus

  const colour = useMemo<'exclusive' | 'highlight-primary-dark' | 'lux-plus' | undefined>(() => {
    if (inclusion.isFlash) return 'exclusive'
    if (highlighted) return 'highlight-primary-dark'
    if (isLuxPlusBonus) return 'lux-plus'

    return undefined
  }, [inclusion.isFlash, highlighted, isLuxPlusBonus])

  return <Container>
    <Icon
      size="S"
      colour={colour}
    />
    {endIcon && <DescriptionCell>
      <BodyText
        variant="medium"
        weight={highlighted ? 'bold' : undefined}
        lineClamp={lineClamp}
      >
        {inclusion.description}
      </BodyText>
      {endIcon}
    </DescriptionCell>}
    {!endIcon && <BodyText
      variant="medium"
      weight={highlighted ? 'bold' : undefined}
      lineClamp={lineClamp}
    >
      {inclusion.description}
    </BodyText>}
  </Container>
}

export default SearchTileRowInclusionItem
